import { ADMIN_SETTINGS } from './relatedSettingsCatalog';

export const pathOnly = (href) => String(href || '').split('?')[0];
export const within = (path, href) => path === href || path.startsWith(`${href}/`);
/** Hebrew-friendly search: quotes / geresh ignored, every word must appear */
export const norm = (v) => String(v || '').replace(/["'״׳`]/g, '').toLowerCase();
export const matches = (text, query) => {
  const hay = norm(text);
  return norm(query).split(/\s+/).filter(Boolean).every((w) => hay.includes(w));
};

/** a catalog entry → where it opens for this user (null = the user has no such screen) */
export function resolveSetting(s, screens) {
  const t = s.target || {};
  if (t.nav) {
    const screen = screens.find((x) => x.key === t.nav);
    if (!screen) return null;
    return { ...s, path: pathOnly(screen.href), query: t.query, where: screen.label, focus: t.focus };
  }
  if (t.path) {
    const screen = screens.find((x) => within(t.path, pathOnly(x.href)));
    if (!screen && t.path !== '/profile') return null;
    return { ...s, path: t.path, query: t.query, where: screen?.label || s.title, focus: t.focus };
  }
  return null;
}

export function availableSettings(screens) {
  return ADMIN_SETTINGS.map((s) => resolveSetting(s, screens)).filter(Boolean);
}
